import './polyfill';
import React, {useContext, useEffect} from 'react';
import * as AppContext from './AppContext';
import Layout from './Components/Layout';
// import ActivityIndicator from './Components/ActivityIndicator';
import ActivityIndicator from './Components/Spinner';
import {Font} from '@react-pdf/renderer';
import {ConfigProvider} from 'antd';
import 'antd/dist/reset.css';
const config = require('./data.json');

if (!config.debug || typeof window === 'undefined') {
  console.log = () => 0;
  console.group = () => 0;
  console.groupEnd = () => 0;
}

Font.register({
  family: 'MiSans',
  src: '/MiSans-Normal.ttf',
});

Font.registerHyphenationCallback((word) => {
  if (word.length === 1) {
    return [word];
  }

  return Array.from(word)
    .map((char) => [char, ''])
    .reduce((arr, current) => {
      arr.push(...current);
      return arr;
    }, []);
});

export function PageContainer(props) {
  return (
    <>
      <WithPageContext {...props}>
        <ConfigProvider
          theme={{
            hashed: false,
            token: {
              fontFamily: '-apple-system, Noto Sans TC, sans-serif',
              colorPrimary: config.colors.main,
              colorLink: config.colors.text,
              colorText: config.colors.text,
              borderRadius: 2,
            },
            components: {
              Button: {
                colorText: config.colors.text,
                paddingBlock: 7,
                paddingInline: 40,
                controlHeight: 38,
                controlHeightLG: 40,
                controlHeightSM: 24,
              },
              Select: {
                margin: 5,
                flexBasis: 150,
              },
              Modal: {
                contentPadding: 0,
                headerBorderBottom: '1px solid #f0f0f0',
                headerMarginBottom: 0,
                footerBorderTop: '1px solid #f0f0f0',
              },
            },
          }}>
          <Layout {...props} seo={props.pageContext.seo || {}}>
            {props.children}
          </Layout>
        </ConfigProvider>
      </WithPageContext>
    </>
  );
}

function WithPageContext({pageContext, children}) {
  const app = useContext(AppContext.Context);
  // const {prjConfig} = pageContext;

  useEffect(() => {
    (async () => {
      if (!app.state.user) {
        try {
          app.actions.setAutoLoginLoading(true);
          await app.actions.autoLogin();
          app.actions.getCart();
        } catch (err) {
          console.warn('autologin error', err);
        }
        app.actions.setAutoLoginLoading(false);
      }
    })();
  }, [app.actions, app.state.user]);

  return children;
}

export function AppRoot(props) {
  return (
    <AppContext.Provider {...props}>
      {props.children}
      <ActivityIndicator />
    </AppContext.Provider>
  );
}
